import CampaignDetailModal from "./CampaignDetailModal";
import CampaignDetailsCard from "./CampaignDetailsCard";
import { useState } from "react";

const CampaignDetailInfoCards = ({ campaignDetails,orderedData }) => {
  const [showCampaignDetailModal, setShowCampaignDetailModal] = useState(false);

  const toggleCampaignDetailModal = () => {
    setShowCampaignDetailModal(!showCampaignDetailModal);
  }

  return (<>
    {showCampaignDetailModal && <CampaignDetailModal {...campaignDetails} onClose={toggleCampaignDetailModal} />}
    <div className="campaign-detail-info-cards">
      <CampaignDetailsCard {...campaignDetails} orderedData={orderedData} toggleCampaignDetailModal={toggleCampaignDetailModal} />
    </div>
  </>
  );
};

export default CampaignDetailInfoCards;
